<template>
  <div class="contentDiv">
    <div class="cover scrollable-div">

      <HeaderContainer :active-index="currentMenuIndex" @menu-select="onMenuSelect"/>

      <div class="lun_bo_img">
        <el-carousel indicator-position="none">
          <el-carousel-item v-for="item in carouselItems" :key="item.id">
            <img :src="item.image" :alt="item.title" class="carousel-image">
            <!--                <div class="carousel-caption">-->
            <!--                  <h3>{{ item.title }}</h3>-->
            <!--                  <p>{{ item.description }}</p>-->
            <!--                </div>-->
          </el-carousel-item>
        </el-carousel>
      </div>


      <el-row class="curresInfo" :gutter="20" style="margin-left: 0px; margin-right: 0px; width: 1170px">
        <!-- 左侧80%  /*当前期信息*/-->
        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16" style="padding: 0px">
          <div class="responsive-left vertical-layout-container">
            <!-- 上部10% -->
            <el-row class="top-row" :gutter="16">
              <el-col :span="24">
                <div class="top-content">
                  <!-- 这里放置上部10%的内容 -->
                  <div class="top-content_left">{{lotteryRecordOne.type}}</div>
                  <div class="top-content_right">{{lotteryRecordOne.nextDateNo}} 期開獎時間：{{lotteryRecordOne.nextDateTime}}</div>
                </div>
              </el-col>
            </el-row>

            <!-- 下部90% -->
            <el-row class="bottom-row" :gutter="20" >
              <el-col :span="24">
                <div class="bottom-content" style="width: 100%">
                  <!-- 这里放置原有表格内容 -->
                  <!-- 使用 el-row 创建行布局 -->
                  <el-row class="content-row" :gutter="20" style="width: 100%;    padding-top: 38px;">
                    <!-- 左侧60%列 -->
                    <el-col :span="14" class="left-column">
                      <div class="left-content">
                        <!-- 这里放置左侧内容 -->
                        <div class="left-content_info_title">{{lotteryRecordOne.type}} 第 <span style="color: red;">{{ lotteryRecordOne.dateNo }}</span> 期</div>

                        <div class="num">
                          <span class="ball ball_margin-top"><span v-if="lotteryRecordOne.numberOne" :class="['balls-size50', randomColor()]">{{ lotteryRecordOne.numberOne }}</span></span>
                          <span class="ball ball_margin-top"><span v-if="lotteryRecordOne.numberTwo" :class="['balls-size50', randomColor()]">{{ lotteryRecordOne.numberTwo }}</span></span>
                          <span class="ball ball_margin-top"><span v-if="lotteryRecordOne.numberThree" :class="['balls-size50', randomColor()]">{{ lotteryRecordOne.numberThree }}</span></span>
                          <span class="ball ball_margin-top"><span v-if="lotteryRecordOne.numberFour" :class="['balls-size50', randomColor()]">{{ lotteryRecordOne.numberFour }}</span></span>
                          <span class="ball ball_margin-top"><span v-if="lotteryRecordOne.numberFive" :class="['balls-size50', randomColor()]">{{ lotteryRecordOne.numberFive }}</span></span>
                          <span class="ball ball_margin-top"><span v-if="lotteryRecordOne.numberSix" :class="['balls-size50', randomColor()]">{{ lotteryRecordOne.numberSix }}</span></span>
                          <span v-if="lotteryRecordOne.numberSeven" class="ball ball_margin-top font-red" style="font-size: 20px; padding: 0px 0px 0px 5px;">+</span>
                          <span class="ball ball_margin-top"><span v-if="lotteryRecordOne.numberSeven" :class="['balls-size50', randomColor()]">{{ lotteryRecordOne.numberSeven }}</span></span>
                        </div>
                      </div>
                    </el-col>

                    <!-- 右侧40%列 -->
                    <el-col :span="10" class="right-column">
                      <div class="right-content">
                        <!-- 这里放置右侧内容 -->
                        <countdown-timer
                            v-if="showTimer"
                            :seconds="seconds"
                            :show-hours="true"
                            @time-up="handleTimeUp"
                        />
                        <div  class="history">
                          <a  @click="routerUrl('/lotteryRecordList')" style="color: rgb(0, 0, 0);">歷史開獎查詢 <span style="color: red;">></span></a>
                        </div>

                        <el-button @click="monikaijiang()" style="float: right;margin-top: 19px" size="small" type="primary">模拟开奖</el-button>

                      </div>

                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <!-- 右侧20% -->
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="padding: 0">
          <div class="responsive-right" style="margin-left: 10px;">
            <div class="responsive-right_jiangli">
              <div class="responsive-right_jiangli_left">頭獎</div>
              <div class="responsive-right_jiangli_right">每註${{ lotteryRecordOne.onePeopleMoney }}</div>
            </div>
            <div class="responsive-right_jiangli">
              <div class="responsive-right_jiangli_left">二獎</div>
              <div class="responsive-right_jiangli_right">每註${{ lotteryRecordOne.twoPeopleMoney }}</div>
            </div>
            <div class="responsive-right_jiangli">
              <div class="responsive-right_jiangli_left">三獎</div>
              <div class="responsive-right_jiangli_right">每註${{ lotteryRecordOne.threePeopleMoney }}</div>
            </div>
            <div class="responsive-right_jiangli">
              <div class="responsive-right_jiangli_left">四獎</div>
              <div class="responsive-right_jiangli_right">每註${{ lotteryRecordOne.fourPeopleMoney }}</div>
            </div>
            <div class="responsive-right_jiangli">
              <div class="responsive-right_jiangli_left">五獎</div>
              <div class="responsive-right_jiangli_right">每註${{ lotteryRecordOne.fivePeopleMoney }}</div>
            </div>
            <div class="responsive-right_jiangli">
              <div class="responsive-right_jiangli_left">六獎</div>
              <div class="responsive-right_jiangli_right">每註${{ lotteryRecordOne.sixPeopleMoney }}</div>
            </div>

            <div class="responsive-right_jiangli">
              <div class="responsive-right_jiangli_left">七獎</div>
              <div class="responsive-right_jiangli_right">每註${{ lotteryRecordOne.sevenPeopleMoney }}</div>
            </div>

          </div>
        </el-col>
      </el-row>



      <div class="pure open_jiang" >
        <div class="list_">
          <div class="list_name">開獎公告</div>
          <a @click="routerUrl('/lotteryRecordList')" class="list_more"><b>+</b>更多</a>
        </div>
        <el-table :data="lotteryRecordFour" :key="key" stripe border style="width: 100%" class="kj_tba">
          <el-table-column  prop="type" label="彩種"/>
          <el-table-column prop="dateNo" label="期號"/>
          <el-table-column  prop="winningTime" label="開獎時間"/>
          <el-table-column width="350px" prop="bankAccount" label="開獎號碼">
            <template #default="scope">
              <!-- 在这里定义自定义模板 -->
              <div class="">
                <span  class="ball"><span :class="['balls-size30', randomColor()]">{{ scope.row.numberOne }}</span></span>
                <span class="ball"><span  :class="['balls-size30', randomColor()]">{{ scope.row.numberTwo }}</span></span>
                <span class="ball"><span  :class="['balls-size30', randomColor()]">{{ scope.row.numberThree }}</span></span>
                <span class="ball"><span  :class="['balls-size30', randomColor()]">{{ scope.row.numberFour }}</span></span>
                <span class="ball"><span  :class="['balls-size30', randomColor()]">{{ scope.row.numberFive }}</span></span>
                <span class="ball"><span  :class="['balls-size30', randomColor()]">{{ scope.row.numberSix }}</span></span>
                <span class="ball font-red" style="font-size: 20px; padding: 0px 0px 0px 5px;">+</span>
                <span  class="ball"><span  :class="['balls-size30', randomColor()]">{{ scope.row.numberSeven }}</span></span>
              </div>
            </template>

          </el-table-column>
          <el-table-column width="180px" prop="totalAmount" label="獎池滾存"/>
          <el-table-column prop="weekDay" label="开奖日"/>
<!--          <el-table-column prop="createTime" label="詳情">-->
<!--            <a><img src="../assets/details.gif" alt="詳情"></a>-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="createTime" label="走勢">-->
<!--            <a><img src="../assets/zst_01.gif" alt="走勢"></a>-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="createTime" label="歷史">-->
<!--            <a><img src="../assets/history.gif" alt="歷史"></a>-->
<!--          </el-table-column>-->
<!--          <el-table-column width="100px" label="暫無分類">暫無分類</el-table-column>-->

        </el-table>
      </div>




      <footer>
        <div class="foot_con pub_case pure">
          <div class="link_foo">
            <a href="" target="_blank">聯繫我們</a> |
            <a href="" target="_blank">反饋意見</a> |
            <a href="" target="_blank">私密條款</a> |
            <a href="" target="_blank">私密條款</a> |
            <a href="" target="_blank">免責聲明</a> |
            <a href="" target="_blank">網頁指南</a> |
          </div>
          <div class="copyRight at_on">
            @2011 澳門銀河娛樂有限公司版權所有 不得轉載
          </div>
        </div>
      </footer>
    </div>
  </div>

</template>

<script>
import {lotteryRecordTopOne, lotteryRecordTopFour} from "@/js/api/WebIndexApi";
import HeaderContainer from '@/components/HeaderContainer.vue'
import CountdownTimer from './CountdownTimer.vue'

export default {
  name: 'WebIndex',
  components: {
    HeaderContainer,
    CountdownTimer
  },
  data() {
    return {
      showTimer:false,
      seconds:0,
      currentMenuIndex: '1', // 根据当前路由设置: 1,
      carouselItems: [
        {
          id: 1,
          title: '',
          description: '',
          image: require('../assets/templatemo_01.jpg')
        },
        {
          id: 2,
          title: '第二张幻灯片',
          description: '这是第二张幻灯片的描述内容',
          image: require('../assets/templatemo_02.jpg')
        },
        {
          id: 3,
          title: '第三张幻灯片',
          description: '这是第三张幻灯片的描述内容',
          image: require('../assets/templatemo_03.jpg')
        }
      ],
      lotteryRecordOne: {
        id: 1,
        type: "澳門銀河娛樂",
        nextDateNo: " 2025085",
        nextDateTime: "2025-07-16 21:30:00",
        dateNo: "2025078",
        winningTime: "2025-06-30",
        numberOne: "11",
        numberTwo: "18",
        numberThree: "22",
        numberFour: "43",
        numberFive: "36",
        numberSix: "28",
        numberSeven: "35",
        totalAmount: "12億69,582,135元",
        weekDay: "星期一",
        onePeopleNum: 0,
        onePeopleMoney: 1.0E7,
        twoPeopleNum: 31,
        twoPeopleMoney: 50000.0,
        threePeopleNum: 1984,
        threePeopleMoney: 200.0,
        fourPeopleNum: 14158,
        fourPeopleMoney: 50.0,
        fivePeopleNum: 148124,
        fivePeopleMoney: 10.0,
        sixPeopleNum: 1574159,
        sixPeopleMoney: 5.0,
        sevenPeopleMoney: 2415887,
        sevenPeopleNum: 1.0,
        createTime: "2025-07-01 16:02:36"
      },
      lotteryRecordFour: [
        {
          id: 1,
          type: "澳門銀河娛樂",
          dateNo: "2025078",
          winningTime: "2025-06-30",
          numberOne: "11",
          numberTwo: "18",
          numberThree: "22",
          numberFour: "43",
          numberFive: "36",
          numberSix: "28",
          numberSeven: "35",
          totalAmount: "12億69,582,135元",
          weekDay: "星期一",
          onePeopleNum: 0,
          onePeopleMoney: 1.0E7,
          twoPeopleNum: 31,
          twoPeopleMoney: 50000.0,
          threePeopleNum: 1984,
          threePeopleMoney: 200.0,
          fourPeopleNum: 14158,
          fourPeopleMoney: 50.0,
          fivePeopleNum: 148124,
          fivePeopleMoney: 10.0,
          sixPeopleNum: 1574159,
          sixPeopleMoney: 5.0,
          sevenPeopleMoney: 2415887,
          sevenPeopleNum: 1.0,
          createTime: "2025-07-01 16:02:36"
        }
      ],
      noticeData: {
        "13": {
          title: "威廉希尔欧联最新夺冠赔率及晋级赔率",
          time: "2022-05-14",
          content: "今晚欧联十六强赛将进行次回合的全部8场比赛，权威博彩公司威廉希尔、Bet365最新欧联夺冠赔率"
        },
        "12": {
          title: "公益彩券盈餘12.13億元",
          time: "2022-05-14",
          content: "澳門公益彩券今（21）日表示，2017年03月份為政府創造的公益彩券盈餘為港幣12億13,454,210元，自2017年2月至2017年03月底為止，第4屆公益彩券累積政府公益盈餘達12億13,454,210元，依規定分配其中50%供地方政府辦理社會福利、45%供政府補助國民年金，其餘5%則挹注全民健康保險準備。 　　澳門旅遊娛樂有限公司表示，2017年03月份單月為政府創造的公益彩券盈餘為12.13億元，其中7.83億元分配至各直轄市、縣市政府辦理社會福利之用，惟實際撥付數將依「財政部公益彩券監理委員會組成辦法」第三條規定辦理，7.05億元分配至國民年金，0.78億元則分配至全民健康保險準備。"
        },
        "11": {
          title: "澳門公益彩大樂透創歷喜報",
          time: "2022-05-14",
          content: "澳門公益彩券今（2017.04.29）日表示，2017年04月份為政府創造的公益彩券盈餘為港蔽12億13,454,210元，自2017年2月至2017年03月底為止 創歷史高峰頭獎，澳門大樂透攪珠，第7049期中獎號碼分別為：30,04,20,47,12,23,特別號碼43號，頭獎17註中，每註派彩$8,210,230元，二獎1.5註中， 每註派彩$1,810,530元。 恭喜本期彩金皇位由： 錢女士， 李先生，郭女士，這三位幸運獲得澳門大樂透彩2017年4月29日第7043期皇位頭獎奪主"
        },
        "10": {
          title: "曼联拒绝平局 主场确保晋级",
          time: "2020-11-28",
          content: "欧罗巴十六强赛上一回合曼联客场被罗斯托夫逼平，上半场伊布助攻姆希塔良，下半场被罗斯托夫队前锋布哈洛夫扳平。曼联历史上曾有10次和俄罗斯球队交锋的记录，战绩为2胜7平1负，其中主场战绩为1胜3平。曼联刚刚在足总杯受挫，被劲敌切尔西淘汰出局，埃雷拉还因两次侵犯阿扎尔两黄变一红被罚出场。客队罗斯托夫上一轮联赛主场毫wu建树，与格罗兹握手言和，冬歇期后还未尝败绩。伊布在上一场足总杯被禁赛后，本场归来，已经两场没有进球的他将会是曼联夺回晋级权的主要因素。"
        }
      },
      newsData: {
        "15": {
          title: "逾220位企業家出席里斯本中葡商機論壇",
          time: "2022-05-14",
          content: "澳門新聞網訊“中國與葡語國家企業經貿合作洽談會－普拉亞”圓滿閉幕後，由澳門貿易投資促進局組織的澳門企業家代表團到訪葡萄牙，出席由中國國際貿易促進委員會、葡萄牙經貿投資促進局以及澳門貿促局共同主辦的“中國－葡萄牙－澳門特別行政區企業商機論壇”，該論壇吸引到來到中國內地、葡萄牙以及澳門超過220位企業家出席，共同就中國與葡國家之產能合作進行專題座談討論，大會安排了兩個本澳與葡萄牙企業家的簽約項目。 論壇由葡萄牙國際事務國務秘書Jorge Costa Oliveira、中華人民共和國駐葡萄牙大使蔡潤、葡萄牙經貿投資促進局執行委員Antonio Silva、中國貿促會副會長張偉、澳門貿促局主席張祖榮、國家商務部台港澳司康文副司長致開幕辭。張祖榮在致辭時指出，澳門正積極落實多項中央支持中葡平台建設的舉措，包括建設中葡金融服務平台及葡語系國家人民幣清算中心、建設“中葡商貿合作服務平台綜合體”、成立“中國與葡語國家企業家聯合會”，以及已於6月1日在澳門進行揭牌儀式的“中葡合作發展基金”總部等，推進“三個中心”的建設，充分凸顯澳門作為中國與葡語國家商貿合作服務平台的地位和作用，為企業提供拓展中國內地、葡語國家以至“一帶一路”等市場商機。 論壇期間舉行了以“中國與葡語國家產能合作”專題座談會，環節一先由中國－葡語國家經貿合作論壇（澳門）常設秘書處秘書長徐迎真作主旨發言，並列舉了一系列中國與葡語國家產能合作的優勢，不但有助國家一帶一路倡議的建設，也有助各國互利共贏，希望產能合作能夠為中國與葡語國家之間的貿易創造新高點。環節二則由中國貿促會副部長雷紅擔任主持，由葡萄牙CASCAIS市政廳主席Carlos Carreiras、常州市武進區副區長錢文華、葡萄牙Infraestruturas de Portugal執行委員Amilcar Monteiro、中國華融資產管理股份有限公司總裁助理胡英、中國建築工程（澳門）有限公司助理總經理鍾斌、中葡合作發展基金管理公司總經理金光澤作座談嘉賓，通過各方介紹中國內地及葡萄牙在產能合作領域的相關政策、戰略規劃、投資策略、優惠措施、資源稟賦、優先領域、現實需求等，透過經驗分享以增進各方的了解，創造商機，加強合作。 論壇安排了兩項本地企業與葡萄牙企業的簽約項目，涉及新聞信息交流、保健及衛生用品代理等。 此外，企業家代表團同日出席了“國際葡語市場企業家商會成立15周年酒會暨法國國家美術家協會巴黎國際藝術沙龍金奬得主楊大名教授國畫作品展”，以支持社會各界對澳門平台的推動與建設。"
        },
        "14": {
          title: "國際知名專家聚集澳門探討治癌新技術",
          time: "2022-05-14",
          content: "“第四屆澳門生物醫學科學研討會＂21日在澳門大學揭幕，近300名海外國內知名的生物醫學專家、科研人員共聚一堂，就近期生物醫學重大的新技術、前沿研究深入交流和討論。 　　今屆研討會以“創新＂為題，內容涵蓋生物醫學領域各重大議題，包括診斷造影和藥物傳輸、癌症免疫學、轉化試驗和個人化癌症療法、腫瘤微環境和轉移、新陳代謝、信令網和治療學、發展誘導、生物醫學新技術等。 　　此外，研討會吸引衆國際著名的生物醫學學者出席并發表演說，包括美國加州大學聖塔芭芭拉分校教授Matthew Fisher，中山大學腫瘤防治中心副院長錢朝南、教授朱孝峰，韓國成均館大學教授Dong-Ki Lee，香港大學教授陳志峰，澳門大學教授劉子銘、李子安和潘全威等。 　　“澳門生物醫學科學研討會＂自2014年至今已成功舉辦三屆，每年均邀請多名國際頂尖學者針對各主軸議題的研究發展進行演講分享，藉此聚集各地生物醫學領域的專家學者共同討論，加強學術交流與科研合作，促進生物醫學的創新與發展。(完)"
        },
        "13": {
          title: "澳門今年第四季重開社屋申請",
          time: "2022-05-14",
          content: "澳門特區立法會20日舉行全體大會，辯論重開社屋申請。列席會議的運輸工務司司長羅立文表示，今年第4季會開展新一期社屋申請，未來公屋會集中以大型屋邨形式興建。 　　持續的高樓價和高租金下，澳門不少基層家庭對於社屋申請“望穿秋水”，但面對重開申請遙遙無期急如熱鍋螞蟻。在5月份舉行的立法會全體會議上，議員李靜儀就政府應立即開展社會房屋申請並落實社屋申請恒常機制提出辯論動議，獲得通過。 　　羅立文在當天的辯論會上稱，今年第4季將會開展新一期社屋申請。他還透露，因為社屋輪候者已全部上樓，因此目前已沒有人收取輪候社屋住屋補貼。 　　多位議員追問公屋需求研究報告的進度、今年第4季重開社屋申請的詳情、會否將社屋申請變成恒常機制等問題。羅立文回應指，公屋需求研究報告最遲今年10月完成；至於是否設立社屋申請恒常機制，他表示，修訂社屋法已於2016年12月進入立法程序，未來會提交立法會審議。"
        },
        "12": {
          title: "澳參與發展規劃為旅遊休閒帶來新機遇",
          time: "2022-05-14",
          content: "澳門旅遊、酒店、餐飲、會展及文創範疇多個社團的領導和代表昨日上午到特區政府政策研究室，表達對澳門特區參與《粵港澳大灣區城市群發展規劃》的意見和建議。政策研究室主任劉本立和副主任吳海恩認真聽取了意見。 　　拓“一程多站”旅遊 　　澳門旅遊零售服務業總商會理事長葉榮發，澳門旅遊業議會理事長胡景光，澳門旅遊管理學會會長張健中，澳門旅遊業工商聯會常務理事凌詠兒，澳門酒店協會主席王淑欣，澳門美食同業聯合商會理事長梁仕友，澳門中小型餐飲業商會理事長楊永成，澳門烹飪協會副會長胡達忠，澳門廣告商會會長黃義滿，澳門連鎖加盟商會會員大會主席黃仁民，澳門會議展覽業協會副會長關偉霖，澳門展貿協會秘書長鄧敏華，澳門會展專業管理協會會長曾鳴岐，青年創業智庫協會理事長吳偉恩，澳門漫畫從業員協會會長黃天俊，澳門文化創意產業發展協會秘書長劉陽子，澳門國際海洋經濟商會理事長周中余，代表所在社團表達了有關意見。 　　上述社團領導和代表普遍認為，大灣區建設為促進澳門世界旅遊休閒中心建設提供了新的機遇，對澳門經濟社會可持續發展具有重要意義，同時需要正確處理大灣區城市間的合作與競爭關係，逐步破除合作中的障礙。代表們就今後澳門如何參與大灣區城市群建設提出了多方面意見，包括：強化自身比較優勢，促進大灣區城市間的差異化優勢互補發展；澳門應在專業培訓方面發揮更加積極作用，建設成為亞洲旅遊培訓中心和葡語國家會展人才培訓中心；聯合大灣區其他城市共同開發“一程多站”旅遊線路，將大灣區建設成為大旅遊目的地；推動跨境交通基礎設施的建設，創新通關模式，促進灣區城市間的人流、物流，等等。 　　澳文化產業走出去 　　也有代表建議，大灣區城市可考慮聯合申辦及舉行會展活動；透過與大灣區城市的合作，推動澳門文化產業“走出去”；檢討有關法律制度，推進科技創新；不斷完善人才政策，重視人力資源的培訓和中小企的人力短缺問題；重視海洋經濟，發展世遺旅遊；利用澳門優勢，建設“美食之都”；政府提供資訊服務，支持澳門企業和居民到灣區創業發展；要大力宣傳和弘揚澳門精神，增強特區精神軟實力。"
        },
        // "9":{
        //   title:"伊朗核科学家遇害后，德黑兰爆发抗议活动：“向美国开战！",
        //   time:"2022-05-14",
        //   content:""
        // },
        // "8":{
        //   title:"深夜通报！武汉理工大学：教师王攀的硕士研究生招生资格不予通过",
        //   time:"2022-05-14",
        //   content:""
        // },
        "7": {
          title: "雅鲁藏布江下游水电开发决策敲定，资源量相当于再造3个三峡",
          time: "2020-11-28",
          content: "党中央关于制定‘十四五’规划和2035年远景目标的建议中明确提出‘实施雅鲁藏布江下游水电开发’。这在中央文件中是史无前例的，写得很清楚，是‘实施’。对于水电行业来讲，这是一次历史性机遇。”中国电力建设集团有限公司董事长晏志勇11月26日在中国水力发电工程学会成立40周年纪念大会上说。\n" +
              "\n" +
              "晏志勇说：“我们作为建设施工企业，要抓落实。所以，我一直在思考。我认为，雅鲁藏布江下游水电开发，不仅仅是一项水电工程，而应该是‘五大工程’。”\n" +
              "\n" +
              "第一，是生态工程。雅鲁藏布江下游水电站所发电力和工程建设对地方的贡献，肯定会使得西藏自治区这方热土，为我国“二氧化碳排放力争于2030年前达到峰值，努力争取2060年前实现碳中和”发挥绝对巨大的作用。\n" +
              "\n" +
              "第二，是国家安全工程。包括水资源安全、国土安全等。\n" +
              "\n" +
              "第三，是民生工程。雅鲁藏布江下游水电站投入运行后，每年可以为西藏自治区形成200亿元以上的财政收入，再加上水电站开发对于基础设施建设的拉动作用等，西藏自治区的发展必将发生翻天覆地的变化，当地人民生活的幸福感必将变得更加强大，西藏自治区也会因此对生态保护作出更大贡献。\n" +
              "\n" +
              "第四，是国家重大的能源工程。雅鲁藏布江下游近6000万千瓦水电的开发，每年可提供近3000亿度清洁、可再生、零碳的电力。\n" +
              "\n" +
              "第五，是国际合作工程。随着水电站的开发，电网通了、公路通了，我国与南亚的合作也将更加通畅。\n" +
              "\n" +
              "数据显示，我国水能资源蕴藏量在6.76亿千瓦以上，为世界之最；西藏水能资源理论蕴藏量在2亿多千瓦左右，占全国的30%，居各省区市之首。西藏水能资源主要集中分布在雅鲁藏布江、怒江、澜沧江和金沙江干流。其中，雅鲁藏布江流域干流水能资源最丰富，理论蕴藏量近8000万千瓦，其下游的大拐弯地区更是“世界水能富集之最”，在50公里直线距离内，形成了2000米的落差，汇集了近7000万千瓦的技术可开发资源，规模相当于3个多三峡电站（装机容量2250万千瓦）。但作为我国“西电东送”的能源接续基地，西藏自治区目前水电资源开发程度极低，仅为技术可开发量的1%左右。因此，雅鲁藏布江下游水电的开发，必将对西藏自治区经济社会发展和我国能源电力行业发展具有重大历史意义和现实意义。\n" +
              "\n" +
              "（原标题 重磅丨雅鲁藏布江下游水电开发决策敲定，规模近6000万千瓦，相当于“再造3个三峡”）"
        },
        // "6":{
        //   title:"四天四位代省长密集就位，上任前他们都说了什么？",
        //   time:"2022-05-14",
        //   content:""
        // }
      },
    }
  },
  created() {
   var isMobileDevice= this.checkDevice()
    if(isMobileDevice){
      debugger
      this.$router.replace("/mobileHome");

    }
    this.lotteryRecordTopOne()
    this.lotteryRecordTopFour()
  },
  methods: {
    async monikaijiang() {
      var that = this;
      const numbers = [
        that.lotteryRecordOne.numberOne,
        that.lotteryRecordOne.numberTwo,
        that.lotteryRecordOne.numberThree,
        that.lotteryRecordOne.numberFour,
        that.lotteryRecordOne.numberFive,
        that.lotteryRecordOne.numberSix,
        that.lotteryRecordOne.numberSeven
      ];
      that.lotteryRecordOne.numberOne = '';
      that.lotteryRecordOne.numberTwo = '';
      that.lotteryRecordOne.numberThree = '';
      that.lotteryRecordOne.numberFour = '';
      that.lotteryRecordOne.numberFive = '';
      that.lotteryRecordOne.numberSix = '';
      that.lotteryRecordOne.numberSeven = '';

      for (const num of numbers) {
        const index = numbers.indexOf(num);
        console.log(`第 ${index + 1} 个数字: ${num}`);
        if (index + 1 == 1) {
          that.lotteryRecordOne.numberOne = '' + num;
        }
        if (index + 1 == 2) {
          that.lotteryRecordOne.numberTwo = '' + num;
        }
        if (index + 1 == 3) {
          that.lotteryRecordOne.numberThree = '' + num;
        }
        if (index + 1 == 4) {
          that.lotteryRecordOne.numberFour = '' + num;
        }
        if (index + 1 == 5) {
          that.lotteryRecordOne.numberFive = '' + num;
        }
        if (index + 1 == 6) {
          that.lotteryRecordOne.numberSix = '' + num;
        }
        if (index + 1 == 7) {
          that.lotteryRecordOne.numberSeven = '' + num;
        }

        await this.sleep(1000); // 休眠1秒（1000毫秒）
      }

    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    randomColor() {
      const colors = ["red", "green", "blue"];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    /*主键函数*/
    onMenuSelect(index, indexPath) {
      console.log('选中菜单:', index, indexPath)
    },
    handleTimeUp() {
      //alert('时间到了！')
    },
    resetTimer() {
      this.$refs.countdown.resetTimer()
    },

    checkDevice() {
      debugger
      this.screenWidth = window.innerWidth
      return  this.screenWidth < 768
    },
    routerUrl(url) {
      this.$router.replace(url);
    },
    lotteryRecordTopOne() {
      var that = this;

      lotteryRecordTopOne({}, function (data) {
        console.log(data)
        that.seconds=that.getSeconds(data.result.nextDateTime)
        that.showTimer=true
        console.log(that.seconds)
        data.result.onePeopleMoney = data.result.onePeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.result.twoPeopleMoney = data.result.twoPeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.result.threePeopleMoney = data.result.threePeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.result.fourPeopleMoney = data.result.fourPeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.result.fivePeopleMoney = data.result.fivePeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.result.sixPeopleMoney = data.result.sixPeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.result.sevenPeopleMoney = data.result.sevenPeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        that.lotteryRecordOne = data.result;
      })
    },
    getSeconds(nextDateTimeStr){
      // 假设 data.result.nextDateTime 是一个有效的日期时间字符串，如 "2023-12-31T23:59:59"
      const nextDateTime = new Date(nextDateTimeStr);
      const now = new Date();

// 计算时间差（毫秒）并转换为秒
      const diffInSeconds = Math.floor((nextDateTime - now) / 1000);

// 确保结果不为负数
      const remainingSeconds = Math.max(0, diffInSeconds);
      return remainingSeconds;
    },
    lotteryRecordTopFour() {
      var that = this;
      lotteryRecordTopFour({}, function (data) {
        console.log(data)
        that.lotteryRecordFour = data.result;
      })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
  padding: 0;

  justify-items: center;
}


.contentDiv {
  padding: 0;
  background: rgb(4, 23, 65);
  /*background-image: url("../assets/bgvideo.webp");*/
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  width: 100%;
  height: 100%;
  /*display: flex;*/
  align-items: center; /*定义父元素的元素垂直居中*/
  justify-content: center; /*定义子元素的里的元素水平居中*/
  text-align: center;
}


/*轮播图*/
.carousel-image {
  width: 100%;
  height: 100%;
  //object-fit: cover;
}

.lun_bo_img {

  width: 1170px;
  margin-bottom: 10px;
}

/*当前期信息*/

.vertical-layout-container {
  //height: 240px; /* 使用视口高度 */
  display: flex;
  flex-direction: column;
}

.top-content, .bottom-content {
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;

}

.top-content {
  background-color: #ffc9c9;
  border: 1px solid #d80011;
  color: #d80011;
}

.top-content_left {
  width: 50%;
  text-align: left;
  font-size: 18px;
  font-weight: bold;
}

.top-content_right {
  width: 50%;
  text-align: right;
}
.left-content_info_title{
  text-align: left;
}

.left-content_info_shuangseqiu{
  display: flex;
  align-items: center;  /* 垂直居中 */
  justify-content: center;  /* 水平居中 */
  height: 156px;
}
.left-content_info_shuangseqiu img{
  width: 40px;
}

.history {
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #3f3f3f;
  margin-top: 40px;
  margin-left: 50px;
}


.responsive-right_jiangli{
  display: flex;
  text-align: left;
  background-color: #ffc9c9;
  border: 1px solid #d80011;
  color: #d80011;
  height: 45px;
  line-height: 45px;
  padding: 0px 10px;
}

.responsive-right_jiangli_left{
    width: 40%;
}

.responsive-right_jiangli_right{
  width: 60%;

}

.num{
  padding:54px 0px;
}
.ball {
  display: inline-block;
}
.ball_margin-top{
  margin-top: 40px;
}



.ball .green {
  background-image: url(data:image/png;base64,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);
}
.ball .balls-size50 {
  display: inline-block;
  height: 50px;
  width: 50px;
  text-align: center;
  line-height: 46px;
  background-position: -6px -5px;
  background-size: 60px;
  background-repeat: no-repeat;
  font-size: 24px;
  font-weight: 600;
}
.ball .balls-size30 {
  display: inline-block;
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 36px;
  background-position: 0px 0px;
  background-size: 40px;
  background-repeat: no-repeat;
  font-size: 16px;
  font-weight: 600;
}
.ball .red {
  background-image: url(data:image/png;base64,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);
}
.ball .green {
  background-image: url(data:image/png;base64,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);
}
.ball .blue {
  background-image: url(data:image/png;base64,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);
}

.font-red {
  color: #d80011;
}







.horizontal-nav li {
//margin: 0 15px; //padding: 8px 16px; color: white; border-radius: 4px;
}


.responsive-left, .responsive-right {
  background: #f5f7fa;
  border-radius: 4px;
//min-height: 200px;
}


/*本站新闻*/

.list_ {
  display: flex;
  padding: 0 8px;
  line-height: 40px;
  justify-content: space-between;
  background-color: #2b3e68;
  background-image: linear-gradient(#2b4776, #1f2758);
  position: relative;
  z-index: 2;
}

.list_ .list_name {
  color: #efd749;
  font-size: 16px;
  font-weight: 700;
  min-width: 50%;
  text-align: left;
}

.list_ a {
  padding: 0 10px;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}


.list_con {
  border: 1px solid #27395f;
  border-top: none;
}

.list_con ul {
  display: block;
  padding: 0;
  margin: 0;
}

.list_con ul li {
  display: block;
  text-align: left;
}

li {
  margin: 0px;
  padding: 0px;
  line-height: 25px;
}

.list_con ul li a {
  display: block;
  border-bottom: 1px solid #27395f;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  padding: 0 30px 0 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  line-height: 29px;
  background-color: #1e2b58;
}



.xs_time > div, .kefu_ > div {
  display: flex;
  align-items: center;
}

.xs_time span, .kefu_ span {
  color: #455d89;
}

.xs_time span:nth-of-type(1), .kefu_ span:nth-of-type(1) {
  margin-right: 10px;
}

.xs_time span:nth-of-type(2), .kefu_ span:nth-of-type(2) {
  margin-right: 5px;
}

.xs_time span:nth-of-type(3), .kefu_ span:nth-of-type(3) {
  margin-left: 10px;
  margin-right: 5px;
}



table {
  width: 100%;
}

table th, table td {
  background-color: #fff;
  line-height: 30px;
  font-size: 16px;
  color: #333;
  text-align: center;
}

table th {
  line-height: 40px;
  text-align: center;
}

table th b, table td b {
  color: #962831;
  margin: 0 6px;
  font-weight: bold;
}

table th img, table td img {
  width: 27px;
  margin: 0 2px;
}

.kj_tba th {
  background-color: #4c587e;
  font-size: 14px;
  line-height: 30px;
  color: #e6c35a;
}


.kj_tba tbody {

  height: 400px;
  overflow-y: auto;
  overflow-x: auto;
}

.el-table__row .cell div {
  display: flex !important;
}


.open_jiang{margin-top: 10px;    width: 1170px;
}
@media (max-width: 768px) {

  .link_foo {
    font-size: 4px;
  }

  .copyRight {
    font-size: 4px;
  }

  .logo111 {
    position: absolute;
    margin-top: 14px !important;
    width: 100px !important;
  }

  table th, table td {
    background-color: #fff;
    line-height: 30px;
    font-size: 12px;
    color: #333;
    text-align: center;
  }

  .lun_bo_img {

    height: 300px;
    width: 100%;
    margin-bottom: 10px;
  }
  .curresInfo{
    margin-left: 0px; margin-right: 0px; width: auto !important;
  }

  .open_jiang{
    margin-top: 10px;
    width: auto !important;
  }
}


.scrollable-div {

  overflow-y: auto; /* 垂直滚动 */
  overflow-x: auto; /* 隐藏水平滚动 */

  border: 1px solid #ddd;
  border-radius: 4px;
}

footer .foot_con {
  padding: 15px 0;
  color: #4e6692;
  font-size: 12px;
}

.pub_case {
  margin-left: auto;
  margin-right: auto;
}

footer .link_foo {
  float: right;
}

footer .copyRight {
  float: left;
}

footer .foot_con a {
  color: #4e6692;
}
</style>

